import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Login from '../auth/Login';
import CelebrationModal from '../settings/CelebrationModal';

function UITest() {
  const [showCelebration, setShowCelebration] = useState(false);
  
  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-orange-600 mb-8">UI Component Test Page</h1>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">Login Page</h2>
            <p className="mb-4 text-gray-600">Test the login page with the new diagonal EOS Yes background.</p>
            <Link 
              to="/login" 
              className="inline-block px-6 py-2 bg-orange-500 text-white rounded-lg shadow hover:bg-orange-600 transition-all duration-300"
            >
              View Login Page
            </Link>
          </div>
          
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">Celebration Modal</h2>
            <p className="mb-4 text-gray-600">Test the celebration modal with navigation to main page.</p>
            <button 
              onClick={() => setShowCelebration(true)}
              className="inline-block px-6 py-2 bg-orange-500 text-white rounded-lg shadow hover:bg-orange-600 transition-all duration-300"
            >
              Show Celebration Modal
            </button>
          </div>
          
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">Company Config</h2>
            <p className="mb-4 text-gray-600">Test the company config form with celebration modal on submission.</p>
            <Link 
              to="/config-test" 
              className="inline-block px-6 py-2 bg-orange-500 text-white rounded-lg shadow hover:bg-orange-600 transition-all duration-300"
            >
              Test Company Config
            </Link>
          </div>
          
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">Real Company Config</h2>
            <p className="mb-4 text-gray-600">Test the actual company config page (requires login).</p>
            <Link 
              to="/company-config" 
              className="inline-block px-6 py-2 bg-orange-500 text-white rounded-lg shadow hover:bg-orange-600 transition-all duration-300"
            >
              View Company Config
            </Link>
          </div>
        </div>
        
        <div className="bg-white p-6 rounded-lg shadow-md mb-8">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">Quick Modal Test</h2>
          <p className="mb-4">Use this section to test the celebration modal directly without any forms.</p>
          <div className="flex space-x-4">
            <button 
              onClick={() => {
                console.log("Direct modal test");
                setShowCelebration(true);
              }}
              className="inline-block px-6 py-2 bg-green-500 text-white rounded-lg shadow hover:bg-green-600 transition-all duration-300"
            >
              Test Modal Directly
            </button>
            
            <Link 
              to="/celebration-test" 
              className="inline-block px-6 py-2 bg-blue-500 text-white rounded-lg shadow hover:bg-blue-600 transition-all duration-300"
            >
              Dedicated Modal Test
            </Link>
          </div>
        </div>
      </div>
      
      <CelebrationModal 
        isOpen={showCelebration} 
        onClose={() => {
          console.log("Test modal closed");
          setShowCelebration(false);
        }} 
        userName="Test User" 
      />
    </div>
  );
}

export default UITest; 